export default [
  {
    url: "/",
    name: "Dashboard",
    slug: "admin-home",
    icon: "PieChartIcon",
  },
  /*{
    url: "/users",
    name: "Users",
    slug: "admin-users",
    icon: "UsersIcon",
  },*/
  /*{
    url: "/venues",
    name: "Venues",
    slug: "admin-venues",
    icon: "HomeIcon",
  },*/
  
  {
    url: "/planday",
    name: "Planday",
    slug: "admin-planday",
    icon: "SettingsIcon",
  },
]
